// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import React, { ReactElement } from 'react';
import { PinType, usePin } from '../context';

import './PinButton.scss';

interface PinButtonProps {
    data: PinType;
    className?: string;
}

export const PinButton = ({ data, className }: PinButtonProps): ReactElement => {
    const { togglePin, isPinned, getLimit } = usePin();

    const pinned = isPinned(data);
    const limit = getLimit(data);
    return (
        <THButton
            icon={!pinned ? <ICONS.PinIcon /> : <ICONS.UnpinIcon />}
            type="link"
            disabled={!limit && !pinned}
            className={classList('pin-button', className, { pinned })}
            onClick={(): void => togglePin(data)}
        />
    );
};
